import 'alpinejs'

require('../bootstrap')
require('../plugins')

window.rater = require('rater-js')
